var React = require('react');

function RightArrowLarge (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"V4","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Menu-Mobile","transform":"translate(-183.000000, -332.000000)","fill":"#222A35","fillRule":"nonzero"},React.createElement("g",{"id":"Mobile-Menu","transform":"translate(0.000000, 71.000000)"},React.createElement("path",{"id":"Line-2-Copy-4","d":"M332.301076,261.081374 L341.519862,266.247572 L332.317629,271.443197 L331.825976,270.572406 L338.592,266.751 L183.000799,267.000798 L182.999202,266.000799 L338.592,265.752 L331.812208,261.953731 L332.301076,261.081374 Z"})))));
}

RightArrowLarge.defaultProps = {"width":"159px","height":"11px","viewBox":"0 0 159 11","version":"1.1"};

module.exports = RightArrowLarge;

RightArrowLarge.default = RightArrowLarge;
